import { Box, Button, Text } from "@chakra-ui/react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";

type Props = {
  currentPage: number;
  onPageChange: (page: number) => void;
  isAllpage?: boolean;
}

const SimplePage = ({ currentPage, onPageChange, isAllpage }:Props) => {
  // const totalPages = Math.ceil(total / pageSize);

  const handleNextPage = () => {
    onPageChange(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <Box display="flex" fontSize="14px" p={4} justifyContent="center" alignItems="center">
      <Button fontSize="14px" size='sm' onClick={handlePrevPage} disabled={currentPage === 1} leftIcon={<BsChevronCompactLeft />} mr={4}>
        上一页
      </Button>
      <Button fontSize="14px" size='sm' variant='solid' onClick={handleNextPage} disabled={isAllpage} rightIcon={<BsChevronCompactRight />}>
        下一页
      </Button>
    </Box>
  );
};

export default SimplePage;